import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { PageHeader, Empty } from "@/components/PageHeader";
import { FileText, Loader2 } from "lucide-react";

const STATUS_COLOR = { interested: "#F5A623", reviewing: "#002EA6", shortlisted: "#10B981", declined: "#71717A" };

export default function Applications() {
  const navigate = useNavigate();
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/me/interests").then(({ data }) => setItems(data)); }, []);
  return (
    <div>
      <PageHeader overline="Roles you've signaled" title="My Applications" />
      <div className="p-8">
        {!items && <div className="flex justify-center py-24"><Loader2 className="h-6 w-6 animate-spin text-muted-foreground" /></div>}
        {items && items.length === 0 && <Empty icon={FileText} title="No applications yet" hint="Browse opportunities and signal interest to track them here." />}
        {items && items.length > 0 && (
          <div className="space-y-px bg-black/10 border border-black/10">
            {items.map((it) => (
              <button key={it.id} onClick={() => it.job && navigate(`/candidate/jobs/${it.job.id}`)}
                className="w-full bg-white p-5 flex items-center justify-between hover:bg-[#F1F1F3] transition-colors text-left">
                <div>
                  <p className="font-medium">{it.job?.title || "Role"}</p>
                  <p className="overline text-[0.55rem] mt-1">{it.job?.organization_name || ""} · applied {new Date(it.submitted_at).toLocaleDateString()}</p>
                </div>
                <span className="flex items-center gap-1.5 text-xs capitalize"><span className="h-1.5 w-1.5 rounded-full" style={{ background: STATUS_COLOR[it.status] || "#71717A" }} />{it.status}</span>
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
